import { render } from "./CreateGroup.vue?vue&type=template&id=5f44aace&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"

import "./CreateGroup.vue?vue&type=style&index=0&id=5f44aace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f44aace"]])

export default __exports__